import React, {PureComponent} from 'react';
import {isMobile} from 'react-device-detect';
import { withTranslation } from 'react-i18next';

import axios from "../../../axios-defaults";
import UserContext from '../../../context/user-context';
import Aux from "../../../hoc/Auxiliary";

import CardSummary from "../../../components/Cards/CardSummary";
import PageTitle from "../../../components/Commons/PageTitle";
import Spinner from "../../../components/UI/Spinner";
import Tabs from '../../../components/UI/Tabs/Tabs';

import SummaryTab from '../../../components/Accounts/Account/Summary/Summary';
import TransactionsTab from '../../../components/Accounts/Account/Transactions/Transactions';
import ConsumptionTab from '../../../components/Accounts/Account/Consumption/Consumption';
import CommsTab from '../../../components/Accounts/Account/Communications/Communications';
import TanksTab from '../../../components/Accounts/Account/Tanks/Tanks';
import InvoicesTab from '../../../components/Accounts/Account/Invoices/Invoices';
import DeliveriesTab from '../../../components/Accounts/Account/OrdersHistory/OrdersHistory'
import formatDate from "../../../components/Utils/Date/formatDate";
import {getTrackingUserId, getUserId, isAgentSession, isHarnoisOrClient} from "../../../components/Utils/GTM/GTMHelper";
import {userHaveSpecificPermission} from "../../../components/Utils/UserHelper";

import {
    DEFAULT_DATE,
    TODAY,
    TODAY_MINUS_14,
    TODAY_MINUS_30,
    DEFAULT_FILTER_ALL_PAGE_NUMBER,
    DEFAULT_FILTER_ALL_PAGE_SIZE
} from "../../../components/Accounts/Account/Tables/DateFilters";


class Account extends PureComponent {
    static contextType = UserContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            loadingAdjustment : false,
            accountAdjustment : null,
            id : this.props.match.params.id,
            subaccount : null,
            cardsSummary : null,
            transactions : null,
            communications : null,
            statements : null,
            documents_status : null,
            tanks : null,
            invoices : null,
            enableCurrentPeriod : true,
            currentPeriodStart : null,
            currentPeriodEnd : null,
            currentPeriod: false,
            isSpecific: false,
            startDate : null,
            endDate : null,
            pageNumber: DEFAULT_FILTER_ALL_PAGE_NUMBER,
            pageSize: DEFAULT_FILTER_ALL_PAGE_SIZE,
            dateFilterType : 'current_period',
            lang : this.props.i18n.language,
            overrideTab : null,
            customFilters : null,
            isMobile: isMobile,
            displayMode: (isMobile?'card':'list'),
            currentTab: null,
			reloadCardSummary: 0,
			isDataLayerSend : false
        };
        window.addEventListener("resize", this.handleResizeChange);
        // window.addEventListener("load", this.handleResizeChange);

    }

    componentDidMount(){
        this.setDisplayMode(null);
        this.getCurrentSubaccount();
        this.getAdjustmentAccount();
        this.pushToRecentlyViewed();
    }

	componentDidUpdate() {
		if(this.props.user.account !== null && this.props.user.infos !== null && this.state.subaccount !== null && !this.state.isDataLayerSend){
			this.props.setDataLayerData({
				'element_sous_compte': this.state.subaccount.subAccountType["descriptionFr"],
				'element_sous_compte_category': this.state.subaccount.accountCategory["descriptionFr"],
				'element_store' : this.state.subaccount.subAccountCode,
				'user_session': isHarnoisOrClient(this.props.user.infos),
				'agent_session': isAgentSession(this.props.user.infos),
				'user_id': getTrackingUserId(this.props.user.infos),
			});

			this.setState({isDataLayerSend: true});
		}
	}

    setDisplayMode = (mode = null) => {
        if(!mode) {
            mode = this.getStoredDisplayMode();
        }
        localStorage.setItem('displayMode',mode);
        this.setState({displayMode:mode});
    }

    handleResizeChange = () => {
        const mobileMatch = window.matchMedia && window.matchMedia("(max-width: 480px)").matches;
        if (mobileMatch !== this.state.isMobile) {
            this.setState({isMobile : mobileMatch});
            this.setDisplayMode(mobileMatch?'card':'list');
        }
    }

    getStoredDisplayMode = () => {
        let mode = localStorage.getItem('displayMode');
        if(!mode) {
            mode = this.state.displayMode;
        }
        if(mode == "map"){
            mode = 'list'
        }
        return mode;
    }

    pushToRecentlyViewed = () => {
        axios.post(`/subaccounts/recently_viewed`,{account_id: this.state.id})
            .catch(error => { console.log('[Account.js] : RecentlyViewed ajax error in pushToRecentlyViewed()',error.message); });
    }

    getCurrentSubaccount = () => {
        this.setState({loading: true});
        axios.get(`/subAccounts?subAccountCode=${this.state.id}`)
            .then(response => {
                if (response.data.succeeded) {
                    const {nextPreauthorizePaymentDate, lastStatementDate} = response.data.data;

                    let endDate = nextPreauthorizePaymentDate;
                    if (!nextPreauthorizePaymentDate)  {
                        endDate = formatDate(TODAY);
                    } else if(nextPreauthorizePaymentDate === lastStatementDate) {
                        endDate = `${nextPreauthorizePaymentDate.split("T")[0]}T23:59:59.999Z`;
                    }

                    let startDate = lastStatementDate;
                    
                    let enableCurrentPeriod = true;
                    let dateFilterType;

                    if(window.location.hash === '#deliveries'){
                        dateFilterType = 'current_orders';
                        enableCurrentPeriod = false
                    }else{
                        dateFilterType = 'current_period';
                        if (!lastStatementDate) {
                            enableCurrentPeriod = false
                            dateFilterType = 'last_all';
                        }
                    }

                    this.setState({
                        subaccount : response.data.data,
                        currentPeriodStart: startDate,
                        enableCurrentPeriod: enableCurrentPeriod,
                        currentPeriodEnd: formatDate(TODAY)
                    },() => {
                        this.setDateFilterType(dateFilterType);
                    });
                    this.setState({loading: false});
                }
            }).catch(error => {
                console.log('[Account.js] : Ajax error in getCurrentSubaccount()', error.message)
                this.setState({loading: false});
            });
    }

    getAdjustmentAccount = () => {
        this.setState({loadingAdjustment: true});
        axios.get(`/accounts/subaccounts`)
            .then(response => {
                let local_adjustmentAccount = null;
                if (response.data.succeeded) {
                        if(response.data.data && response.data.data.length !== 0){
                            let allSubAccounts = response.data.data;
                            local_adjustmentAccount = allSubAccounts.find((elem)=> elem.subAccountDisplayMode.code === "A");
                        }
                    this.setState({accountAdjustment : local_adjustmentAccount});
                    this.setState({loadingAdjustment: false});
                }
            }).catch(error => {
                console.log('[Account.js] : Ajax error in getAdjustmentAccount()', error.message)
                this.setState({loadingAdjustment: false});
            });
    }

    setStartDate = (date) => {
        if (date != null) {
            const dateFormatted = `${date.toISOString().split("T")[0]}T00:00:00.000Z`;
            this.setState({startDate: dateFormatted, currentPeriod: false});
        }
    }

    setEndDate = (date) => {
        if(date != null){
            const dateFormatted = `${date.toISOString().split("T")[0]}T23:59:59.999Z`;
            this.setState({endDate: dateFormatted, currentPeriod: false});
        }
    }

    setCurrentPeriod = () => {
        this.setState({
            startDate: this.state.currentPeriodStart,
            endDate: this.state.currentPeriodEnd,
            pageNumber: null,
            pageSize: null,
            currentPeriod: true,
            isSpecific: false
        });
    }

    setLastAll = () => {
        this.setState({
            startDate: formatDate(new Date(TODAY_MINUS_14)),
            endDate: formatDate(TODAY,'23:59:59.999Z'),
            pageNumber: DEFAULT_FILTER_ALL_PAGE_NUMBER,
            pageSize: DEFAULT_FILTER_ALL_PAGE_SIZE,
            currentPeriod: false,
            isSpecific: false
        });
    }
    setLast14Days = (refresh = true, component = null) => {
        this.setState({
            startDate: formatDate(new Date(TODAY_MINUS_14)),
            endDate: formatDate(TODAY,'23:59:59.999Z'),
            pageNumber: null,
            pageSize: null,
            currentPeriod: false,
            isSpecific: false
        });
    }

    setLast30Days = () => {
        this.setState({
            startDate: formatDate(new Date(TODAY_MINUS_30)),
            endDate: formatDate(TODAY,'23:59:59.999Z'),
            pageNumber: null,
            pageSize: null,
            currentPeriod: false,
            isSpecific: false
        });
    }

    setSpecificDate = () => {
        this.setState({
            startDate: null,
            endDate: null,
            pageNumber: null,
            pageSize: null,
            currentPeriod: false,
            isSpecific: true
        });
    }

    setCurrentOrder = () => {
        this.setState({
            startDate: formatDate(new Date(TODAY_MINUS_30)),
            endDate: formatDate(TODAY,'23:59:59.999Z'),
            pageNumber: null,
            pageSize: null,
            currentPeriod: false,
            isSpecific: false
        });
    }

    setDateFilterType = (type) => {
        this.setState({ dateFilterType: type });

        switch (type) {
            case 'last_all': this.setLastAll(); break;
            case 'last_14': this.setLast14Days(); break;
            case 'last_30': this.setLast30Days(); break;
            case 'current_orders': this.setCurrentOrder(); break;
            case 'specific_date': this.setSpecificDate(); break;
            case 'current_period': this.setCurrentPeriod(); break;
            default: if (this.state.enableCurrentPeriod) {
                this.setCurrentPeriod(); break;
            } else {
                this.setLastAll(); break;
            }
        }
    }

    changeTabHandler = (tab = null, customFilters = null) => {
        if (!tab) {
            return false;
        }
        this.setState({overrideTab: tab});
        this.setState({customFilters: customFilters});
    }

    resetOverrideTab = () => {
        this.setState({ overrideTab: null });
        //Mode Map only in transaction, switch for list if not in transactions
        if(this.state.displayMode === "map" && document.querySelector(".tab-list-active").id !== "transactions"){
            localStorage.setItem('displayMode','list');
            this.setState({displayMode:'list'});
        }
        if(this.state.dateFilterType === "current_orders" && document.querySelector(".tab-list-active").id !== "deliveries"){
            if (this.state.enableCurrentPeriod) {
               this.setDateFilterType('current_period')
            } else {
                this.setDateFilterType('last_all')
            }
        }
    }

	reloadCardSummaryHandler = () => {
		this.setState({reloadCardSummary: this.state.reloadCardSummary + 1});
	}

    render() {
        const user = this.context.user;

        // Deconstructing state object for better readability
        const {
            loading,
            subaccount,
            startDate,
            endDate,
            pageNumber,
            pageSize,
            dateFilterType,
			currentPeriod,
            enableCurrentPeriod,
            isSpecific,
            lang
        } = this.state;

        let accountTypeAccessor = "descriptionEn";
        if(lang === "fr") { accountTypeAccessor = "descriptionFr"; }

        let html = (<Spinner/>);
        if (subaccount && (startDate || currentPeriod || isSpecific) && !this.state.loadingAdjustment) {

            // Building a props object that will be shared through all tabs
            const tabsSharedProps = {
                startDate : startDate,
                endDate : endDate,
                pageNumber : pageNumber,
                pageSize : pageSize,
                enableCurrentPeriod : enableCurrentPeriod,
                currentPeriod : currentPeriod,
                isSpecific : isSpecific,
                setStartDate : this.setStartDate,
                setEndDate : this.setEndDate,
                changeDateFilterType : this.setDateFilterType,
                dateFilterType : dateFilterType,
                loading : loading,
                subAccountCode : this.state.id,
                subAccountType : this.state.subaccount.subAccountType.code,
                currentDisplayMode: this.state.displayMode,
                setDisplayMode: this.setDisplayMode,
                refreshTabs: this.changeTabHandler
            }

            html = (
                <Aux>
                    <PageTitle
                        title={
                            (subaccount.subAccountName)
                                ? subaccount.subAccountName
                                : subaccount.subAccountType[accountTypeAccessor]
                        } />

                    <CardSummary
                        subaccount={subaccount}
                        refreshTabs={this.changeTabHandler}
                        loadingAdjustment={this.state.loadingAdjustment}
                        accountAdjustment={this.state.accountAdjustment}
                        changeDateFilter={this.setDateFilterType}
						reloadCardSummary={this.reloadCardSummaryHandler}
                    />

                    <Tabs currentTab={this.state.overrideTab} reset={this.resetOverrideTab}>
                        {   // For Cardlock and Credit cards
                            (subaccount.subAccountDisplayMode.code === "K" || subaccount.subAccountDisplayMode.code === "H") &&
                            <div label={this.props.t("tabs.summary")} tabkey="cards-summary">
                                <SummaryTab
									displayCurrentPeriod={currentPeriod}
									reloadCardSummary={this.state.reloadCardSummary}
                                            {...tabsSharedProps}
                                />
                            </div>
                        }
                        {   // For Cardlock and Credit cards
                            ((userHaveSpecificPermission(user,'financial_data') || userHaveSpecificPermission(user,'manage_cards'))
								&& (subaccount.subAccountDisplayMode.code === "K" || subaccount.subAccountDisplayMode.code === "H")) &&
                            <div label={this.props.t("tabs.transactions")} tabkey="transactions">
                                <TransactionsTab displayMode={subaccount.subAccountDisplayMode.code}
												 displayCurrentPeriod={currentPeriod}
                                                 customFilters={this.state.customFilters}
                                                 {...tabsSharedProps}
                                                 isOnlinePaymentAllowed={this.state.subaccount.isOnlinePaymentAllowed}
                                />
                            </div>
                        }
                        {   // For Deliveries and Gas Stations
                            (subaccount.subAccountDisplayMode.code === "L" || subaccount.subAccountDisplayMode.code === "S") &&
                            <div label={this.props.t("tabs.tanks")} tabkey="tanks">
                                <TanksTab
                                    subAccount={subaccount}
                                    refreshTabs={this.changeTabHandler}
                                    changeDateFilter={this.setDateFilterType}
                                    {...tabsSharedProps}
                                />
                            </div>
                        }
                        {   // For Deliveries and Gas Stations
                            (userHaveSpecificPermission(user,'financial_data') && (subaccount.subAccountDisplayMode.code === "L" || subaccount.subAccountDisplayMode.code === "S" || subaccount.subAccountDisplayMode.code === "A" )) &&
                            <div label={this.props.t("tabs.invoices")} tabkey="invoices">
                                <InvoicesTab
                                    displayCurrentPeriod={currentPeriod}
                                    {...tabsSharedProps}
                                />
                            </div>
                        }
                        {   // For Cardlock and Credit cards
                            (subaccount.subAccountDisplayMode.code === "K" || subaccount.subAccountDisplayMode.code === "H") &&
                            <div label={this.props.t("tabs.consumption")} tabkey="consumption">
                                <ConsumptionTab displayMode={subaccount.subAccountDisplayMode.code}
                                                 {...tabsSharedProps}
                                />
                            </div>
                        }
                        {(userHaveSpecificPermission(user,'financial_data') && (subaccount.subAccountDisplayMode.code !== "A")) && <div label={this.props.t("tabs.communications")} tabkey="communications">
                            <CommsTab communicationTypesExcluded={userHaveSpecificPermission(user,'financial_data')?['R']:[['R','F']]}
                                      title={this.props.t('tabs.communications')}
                                      typeLabel={this.props.t('communications.table.search.label')}
                                      {...tabsSharedProps} />
                        </div>}
                        {(userHaveSpecificPermission(user,'financial_data') && (subaccount.subAccountDisplayMode.code !== "A")) && <div label={this.props.t("tabs.statements")} tabkey="statements">
                            <CommsTab communicationType={'R'}
                                      title={this.props.t('tabs.statements')}
                                      typeLabel={this.props.t('statements.table.search.label')}
                                      {...tabsSharedProps} />
                        </div>}
                        {   // For everything unless Cardlock or Credit cards
                            (subaccount.subAccountDisplayMode.code !== "H" && subaccount.subAccountDisplayMode.code !== "K" && subaccount.subAccountDisplayMode.code !== "A") &&
                            <div label={this.props.t("tabs.deliveries")} tabkey="deliveries">
                                <DeliveriesTab {...tabsSharedProps} title={this.props.t('tabs.deliveries')} subaccount={subaccount} />
                            </div>
                        }
                    </Tabs>
                </Aux>
            )
        }

        return (
            <div className='account account-subaccount'>
                <div className="container container--larger">
                    {html}
                </div>
            </div>
        )
    }
}
export default withTranslation()(Account);
